import React, { useState, ChangeEvent, useEffect } from "react";
import { Search, X } from "lucide-react";

interface SearchInputProps {
  placeholder?: string;
  className?: string;
  value?: string;
  onSearch: (term: string) => void;
}

const SearchInput: React.FC<SearchInputProps> = ({
  placeholder = "Search...",
  className = "",
  onSearch,
  value = "",
}) => {
  const [term, setTerm] = useState("");

  useEffect(() => {
    setTerm(value);
  }, [value]);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    setTerm(val);

    const searchTerm = val.trim();
    onSearch(searchTerm.length >= 3 ? searchTerm : "");
  };

  const handleClear = () => {
    setTerm("");
    onSearch("");
  };

  return (
    <div
      className={`flex items-center w-full bg-white border border-gray-200 rounded-xl shadow-sm px-3 py-2 transition-all focus-within:ring-2 focus-within:ring-blue-500 focus-within:border-blue-500 ${className}`}
    >
      <Search size={18} className="text-gray-400 mr-2 shrink-0" />

      <input
        type="text"
        placeholder={placeholder}
        value={term}
        onChange={handleChange}
        className="flex-1 outline-none bg-transparent text-sm text-gray-700 placeholder:text-gray-400"
      />

      {term && (
        <button
          type="button"
          onClick={handleClear}
          className="p-1 rounded-full hover:bg-gray-100 transition"
        >
          <X size={16} className="text-gray-500" />
        </button>
      )}
    </div>
  );
};

export default SearchInput;
